module.exports = __webpack_public_path__ + "static/media/IMG_7891.8764969d.JPG";